import React, { useState } from 'react'
import styles from "./SupportTickets.module.scss"
import DynamicDatatable from '../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable'
import { Col, Container, Input, Row } from 'reactstrap'
import MessagesComp from '../../../../components/AdminPortalComponents/Support&Communication/Messages/Messages.comp'
import SupportTicketsComp from '../../../../components/AdminPortalComponents/Support&Communication/SupportTickets/SupportTickets.comp'
import SearchBar from '../../../../components/common/AdminCommonComponents/SearchBar/SearchBar'
import DetailsCard from '../../../../components/common/AdminCommonComponents/DetailsCard/DetailsCard'
import ComponentBackButton from '../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton'
import DynamicButton from '../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton'

function SupportTickets() {
    const [ticketInfo, setTicketInfo] = useState(false)
    const tableData = [
        { status: "Open", customers: 5, seller: 10 },
        { status: "In Progress", customers: 5, seller: 100 },
        { status: "Awaiting Response", customers: 5, seller: 10 },
        { status: "Closed", customers: 5, seller: 10 },
    ]
    const tableCols = [
        {
            name: "Ticekt Status",
            selector: (row) => row.status,
        },
        {
            name: "Customers",
            selector: (row) => row.customers,
        },
        {
            name: "Sellers",
            selector: (row) => row.seller,
        },
        {
            name: "Total",
            selector: (row) => row.customers + row.seller,
        },
    ]
    return (
        <div className={styles.mainContainer}>
            <Container className={styles.filterTableWrapper}>
                <DynamicDatatable data={tableData} columns={tableCols} type={"yellow"} />
            </Container>
            {!ticketInfo &&
                <>
                    <Container className={styles.filterTableWrapper}>
                        <div className="p-3 d-flex align-items-center justify-content-between">
                            <div className={`fw-semibold fs-4 ${styles.text} `}>Support Tickets </div>
                            <SearchBar placeholder={"Tickets, user name, or ticket ID"} />
                        </div>
                        <SupportTicketsComp onClick={() => setTicketInfo(true)} />
                    </Container>
                </>
            }
            {ticketInfo &&
                <Container fluid className={styles.orderWrapper}>
                    <ComponentBackButton onClick={() => setTicketInfo(false)} />
                    <Row className=''>
                        <Col className=" d-grid">
                            <DetailsCard title={"Ticket Information"} titleColor>

                                <div className={styles.bgCont}>
                                    <div className='d-flex justify-content-between'>
                                        <div className={styles.cont}>
                                            <div className={styles.text1}>Message ID:</div>
                                            <div>001</div>
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <div >User Type:</div>
                                            <div>Customer</div>
                                        </div>
                                    </div>
                                    <div className={styles.cont}>
                                        <div className={styles.text1}>User Name:</div>
                                        <div>John Dow</div>
                                    </div>
                                </div>
                                <div className={styles.cont}>
                                    <div className={styles.yellowText}>Contact Information:</div>
                                    <div className={styles.border}>
                                        <div>
                                            john.doe@example.com
                                        </div>
                                        <div>
                                            +1231212312
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.cont}>
                                    <div className={styles.cont2}>
                                        <div className={styles.blueText}>Subject:</div>
                                        <div >Description:</div>
                                        <div >Assigned To:</div>
                                    </div>
                                    <div>
                                        <div >
                                            Issue with order #124
                                        </div>
                                        <div >
                                            I received the wrong item in my order. Please assist
                                        </div>
                                        <div >
                                            Agent A
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex gap-4'>
                                    <div className={styles.yellowBorder}>
                                        <div className={styles.cont}>
                                            <div className={styles.text3}>Created Date:</div>
                                            <div >
                                                2024-10-20
                                            </div>
                                        </div>
                                        <div className={styles.cont}>
                                            <div className={styles.text3}>Last Update:</div>
                                            <div >
                                                2024-10-20
                                            </div>
                                        </div>

                                    </div>
                                    <div>
                                        <div className={styles.blueBg}>
                                            <div className={styles.cont}>
                                                <div className={styles.text3}>Priority:</div>
                                                <div >
                                                    High
                                                </div>
                                            </div>
                                            <div className={styles.cont}>
                                                <div className={styles.text3}>Status:</div>
                                                <div >
                                                    Open
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </DetailsCard>
                        </Col>
                        <Col className=" d-grid">
                            <DetailsCard title={"Conversion History"} titleColor>
                                {/* <div className='d-flex justify-content-between'> */}
                                <div className={styles.container}>
                                    <div className={styles.cont3}>
                                        <div className={styles.grayBg}>2024-11-20 10:00 AM:</div>
                                        <div className={styles.grayBg}>2024-11-20 10:00 AM:</div>
                                        <div className={styles.grayBg}>2024-11-20 10:00 AM:</div>
                                    </div>
                                    <div>
                                        <div className='mt-3'>Customer submitted the ticker</div>
                                        <div className='mt-3'>Customer submitted the ticker</div>
                                        <div className='mt-3'>Customer submitted the ticker</div>
                                    </div>
                                </div>
                                {/* </div> */}


                            </DetailsCard>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <DetailsCard title={"Actions"} titleColor>
                                <Row className='mt-4  mr-4'>
                                    <Col >
                                        <div>Reply</div>
                                        <Input type='textarea' multiple className={styles.input}/>
                                        <DynamicButton theme='yellow'>Send Reply</DynamicButton>
                                    </Col>
                                    <Col className={styles.btnContainer}>
                                        <div className={styles.btn}>
                                            <DynamicButton theme='sky-blue'>Change Status</DynamicButton>
                                        </div>
                                        <div className={styles.btn}>
                                            <DynamicButton theme='blue'>Close Ticket</DynamicButton>
                                        </div>
                                        <div className={styles.btn}>
                                            <DynamicButton theme='orange'>Assign</DynamicButton>
                                        </div>
                                    </Col>
                                    <div>Add Internal Note</div>
                                    <Input type='textarea' multiple className={styles.input2}  />

                                </Row>
                            </DetailsCard>
                        </Col>
                    </Row>
                </Container>
            }

        </div>
    )
}

export default SupportTickets
